interface ISBIANNUITY_FORMULA {
  lumpSumAmount: number;
  tenureInMonths: number;
  category: 'GENERAL' | 'SENIOR';
}

const getInterestRateByTenure = (
  tenureInMonths: number,
  category: 'GENERAL' | 'SENIOR'
): number => {
  if (tenureInMonths <= 1) return category === 'SENIOR' ? 4.0 : 3.5;
  if (tenureInMonths <= 6) return category === 'SENIOR' ? 6.0 : 5.5;
  if (tenureInMonths <= 7) return category === 'SENIOR' ? 6.5 : 6.0;
  if (tenureInMonths <= 12) return category === 'SENIOR' ? 6.75 : 6.25;
  if (tenureInMonths <= 24) return category === 'SENIOR' ? 7.3 : 6.8;
  if (tenureInMonths <= 36) return category === 'SENIOR' ? 7.5 : 7.0;
  if (tenureInMonths <= 60) return category === 'SENIOR' ? 7.25 : 6.75;
  if (tenureInMonths <= 120) return category === 'SENIOR' ? 7.5 : 6.5;
  return category === 'SENIOR' ? 7.5 : 6.5;
};

export const SBIANNUITY_FORMULA = ({
  lumpSumAmount,
  tenureInMonths,
  category,
}: ISBIANNUITY_FORMULA) => {
  if (
    lumpSumAmount < 1000 ||
    lumpSumAmount > 1e9 ||
    tenureInMonths <= 0 ||
    (category !== 'GENERAL' && category !== 'SENIOR')
  ) {
    const res = 0;
    return {
      monthlyAnnuityPayment: res,
      interestRate: res,
    };
  }

  const annualInterestRate = getInterestRateByTenure(tenureInMonths, category);
  const monthlyInterestRate = annualInterestRate / 12 / 100;
  const factor = Math.pow(1 + monthlyInterestRate, tenureInMonths);

  const monthlyAnnuityPayment =
    (lumpSumAmount * monthlyInterestRate * factor) / (factor - 1);

  return {
    monthlyAnnuityPayment: Number(monthlyAnnuityPayment.toFixed(2)),
    interestRate: Number(annualInterestRate.toFixed(2)),
  };
};
